module.exports = __webpack_public_path__ + "static/media/alexis-bledel-icon.879c3d35.jpg";